import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "total", "label", "className", "clickable"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var StatsWidgetNumber = function StatsWidgetNumber(props) {
  var value = props.value,
    total = props.total,
    label = props.label,
    className = props.className,
    clickable = props.clickable,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var classes = classNames('StatsWidgetNumber', clickable && 'cursor-pointer', className);
  return /*#__PURE__*/React.createElement("div", _extends({}, remainingProps, {
    className: classes
  }), /*#__PURE__*/React.createElement("div", {
    className: 'StatsWidgetNumber-counter'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'StatsWidgetNumber-value'
  }, value), total && /*#__PURE__*/React.createElement("div", {
    className: 'StatsWidgetNumber-total'
  }, total)), label && /*#__PURE__*/React.createElement("div", {
    className: 'StatsWidgetNumber-label'
  }, label));
};
StatsWidgetNumber.defaultProps = {
  value: 0,
  clickable: false,
  onClick: function onClick() {}
};
StatsWidgetNumber.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]).isRequired,
  total: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  clickable: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string
};
export default StatsWidgetNumber;